import { createSelector } from "reselect";
import { getEntities, getResults } from "reducers";
import Immutable from "immutable";
import { denormalize } from "normalizr";
import { bank } from "schemas";

export const getBanks = createSelector(
  (state) => getResults(state).get("banks", Immutable.List()),
  (state) => getEntities(state),
  (result, entities) => denormalize(result, bank.arrayOfBankSchemas, entities)
);
